//note: changes to this list should be mirrored in the file upload backend
export const supportedFileExtensions = new Set([
  "ifc",
  "fbx",
  "obj",
  "b3dm",
  "las",
  "laz",
  "pts",
  "e57",
  "tif",
  "tiff",
  "geotiff",
  "geojson",
  "topojson",
  "kml",
  "kmz",
  "gpkg",
  "gml",
  "json",
  "pdf",
  "zip",
  "rvt",
  "idw",
  "iam",
  "rcp",
  "rcs",
  "dwg",
  "dxf",
  "lgs",
  "mp4",
]);

export const pointcloudFileExtensions = new Set(["las", "laz", "pts", "e57"]);

export const drawingFileExtensions = new Set(["dwg", "dxf"]);

export const getFileExtension = (name: string) => {
  const i = name?.lastIndexOf(".") ?? -1;
  if (i === -1) return null;
  return name.slice(i + 1).toLowerCase();
};

export const formatFileSize = (bytes: number) => {
  if (bytes == null) throw new Error("bytes is required");
  if (isNaN(+bytes)) throw new Error("bytes must be a number");

  if (bytes < 1024) return `${bytes} B`;
  else if (bytes < 1048576) return `${(bytes / 1024).toFixed(2)} KB`;
  else if (bytes < 1073741824) return `${(bytes / 1048576).toFixed(2)} MB`;
  else return `${(bytes / 1073741824).toFixed(2)} GB`;
};

export const sanitizeFilename = (name: string) => {
  if (!name) return name;
  return name.replaceAll(/[^A-Za-z0-9_\-\. ]+/g, "").replaceAll(/[\- ]+/g, "_");
};
